import { InternalAxiosRequestConfig } from 'axios';
import { DIMENSIONALITY_VALUES } from 'constants/businessTool';
import { useUnitRecalculationStore } from 'store/useUnitRecalculationStore';

import { ClientError } from '../types';

const CALCULATION_UNIT_PATH = new RegExp(`/(${Object.values(DIMENSIONALITY_VALUES).join('|')})(?:/|$|\\?)`);

const isCalculationRequest = (config?: InternalAxiosRequestConfig) => {
  if (!config) return false;

  const method = config.method?.toLowerCase();
  const url = `${config.baseURL ?? ''}${config.url ?? ''}`;

  return (method === 'put' || method === 'post') && CALCULATION_UNIT_PATH.test(url);
};

export const markCalculationRequest = (config: InternalAxiosRequestConfig) => {
  if (isCalculationRequest(config)) {
    useUnitRecalculationStore.getState().startRequest();
  }

  return config;
};

export const unmarkCalculationRequest = (config?: InternalAxiosRequestConfig) => {
  if (isCalculationRequest(config)) {
    useUnitRecalculationStore.getState().endRequest();
  }
};

export const unmarkCalculationRequestFromError = (error: ClientError) => {
  unmarkCalculationRequest(error.config);
  return Promise.reject(error);
};
